module.exports = __webpack_public_path__ + "fonts/OpenSans-Regular.57cd57a.ttf";